"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var device_1 = __importDefault(require("./device"));
var devPriKey_1 = __importDefault(require("./devPriKey"));
var protocol_1 = __importDefault(require("./protocol"));
var snapshot_1 = __importDefault(require("./snapshot"));
exports.default = (function (virtual) { return ({
    device: device_1.default(virtual),
    devPriKey: devPriKey_1.default(virtual),
    protocol: protocol_1.default(virtual),
    snapshot: snapshot_1.default(virtual)
}); });



// WEBPACK FOOTER //
// ./src/fetch/index.ts